// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2AhQe","list":"BalanceDue_list__1TbTK","listRow":"BalanceDue_listRow__nbaSn","total":"BalanceDue_total__1fG6d"};